// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2hUvd","content":"styles_content__woEFE","checkbox":"styles_checkbox__iF-tA","checkboxLabel":"styles_checkboxLabel__3A_lq"};